import React from 'react';
import {Col} from 'react-grid-system';
import Title from './general/Title';
import Subtitle from './general/Subtitle';
import DownloadButton from './infoApp/DownloadButton';

interface States {
}

interface Props {
}

class InfoApp extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <Col
                lg={12}>
                <Title
                    title="SmartDesk"/>
                <Subtitle
                    subtitle="Manage desk sharing and activity-based working schemes. Create a better workplace experience for an agile workforce. "/>
                <DownloadButton/>
            </Col>
        )
    }
}

export default InfoApp;
